import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';
// var Bugsnag = require('@bugsnag/js')
// var BugsnagPluginVue = require('@bugsnag/plugin-vue')

// Bugsnag.start({
//     apiKey: bugsnag_api_key,
//     plugins: [new BugsnagPluginVue()]
// });


require('./bootstrap');

window.Vue = require('vue');

window.Vue.filter('toCurrency', function (value) {
    if (!value) return "";

    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits:2,
        minimumFractionDigits:0
    });
    return formatter.format(value);
});


[VueToast].forEach((x) => Vue.use(x));

window.events = new Vue();

window.flash = function (message, alert_type) {
    window.events.$emit("flash", message, alert_type);
}

require('./globel-components');

const app = new Vue({
    el: '#app'
});

// const bugsnagVue = Bugsnag.getPlugin('vue')
// bugsnagVue.installVueErrorHandler(Vue)
